module.exports = "<div>\n  <div>\n    UWAGI\n  </div>\n</div>\n<div>\n</div>\n"